import { CircleX } from 'lucide-react';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import type { TRuleEditorCommonProps } from '../types';
import { HubertButton } from 'components/HubertUI/HubertButton';

interface Props extends TRuleEditorCommonProps {
  hasRules: boolean;
  addRuleDropdown: ReactNode;
  onDeleteAll: () => void;
}

const RulesToolbar = ({ isReadOnly, hasRules, addRuleDropdown, onDeleteAll }: Props) => {
  const { t } = useTranslation('Templates');

  return (
    <div className="flex justify-between">
      {addRuleDropdown}

      {!isReadOnly ? (
        <HubertButton
          size="sm"
          variant="destructive-outline"
          disabled={!hasRules}
          icon={<CircleX />}
          onClick={onDeleteAll}
        >
          {t('question.rules.deleteAllButton')}
        </HubertButton>
      ) : null}
    </div>
  );
};

export default RulesToolbar;
